<template>
    <div>
      <div class="d-block text-center">
        <div>
          <b-form-input required v-model="$root.state.recipeName" :state="$root.state.recipeName.length > 0" placeholder="Nafn á bjór"></b-form-input>
        </div>
        <div>
          <label for="example-datepicker">Hvenær viltu sækja uppskriftina?</label>
          <b-form-datepicker required id="example-datepicker" v-model="fDate" class="mb-2" :date-disabled-fn="dateDisabled" :show-decade-nav="false" :state="fDate.length > 0"></b-form-datepicker>
        </div>
        <p>Ath að það er mikilvægt að sækja pöntun á réttum degi og panta með góðum fyrirvara. Aðeins hægt að sækja á opnunartímum brew.is.</p>
        <div>
          <b-form-input required v-model="fName" :state="fName.length > 5" placeholder="Nafnið þitt"></b-form-input>
        </div>
        <div>
          <b-form-input required v-model="fPhone" :state="fPhone.length > 5" placeholder="Símanúmer"></b-form-input>
        </div>
        <div>
          <b-form-input required v-model="fEmail" :state="fEmail.length > 5" placeholder="E-mail"></b-form-input>
        </div>
        <div>
          <b-form-textarea v-model="fComment" placeholder="Athugasemdir... (td ekki mala)" rows="3"></b-form-textarea>
        </div>
      </div>
      <div>Ath að fara vel yfir allt áður en uppskrift er send inn. Allt sem er pantað hér fer saman í einn poka.</div>
      <b-container>
        <b-row>
          <b-col>
            <b-button variant="success" :disabled="finishOrderCheck" block @click="finishOrder">
              <b-icon icon="arrow-clockwise" animation="spin" v-if="submitting"></b-icon>Staðfesta pöntun
            </b-button>
          </b-col>
        </b-row>
      </b-container>        
    </div>
</template>

<script>

export default {
  name: 'ConfirmRecipeDialog.vue',
  data () {
    return {
      fName: '',
      fEmail: '',
      fPhone: '',
      fDate: '',
      fComment: '',
      text: '',
      submitting: false,
      values: [],
      recipe: [],
      recipeFields: ['name', 'qty']
    }
  },
  methods: {
    finishOrder: function() {
      this.submitting = true;

      localStorage.phone = this.fPhone;
      localStorage.email = this.fEmail;
      localStorage.name = this.fName;
      var that = this;
      fetch ('https://www.brew.is/uppskriftir/send.php', {
        method: 'POST',
        cache: 'no-cache',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({name: this.fName,
                              email: this.fEmail,
                              phone: this.fPhone,
                              pickupDate: this.fDate,
                              comment: this.fComment,
                              total: this.cartTotal,
                              recipeName: this.$root.state.recipeName,
                              recipe: this.$root.state.recipe})
      }).then((response) => response.json())
      .then((data) => {
        if (data.result == 'success')
        {
          that.$bvToast.toast("Uppskriftin þín hefur verið móttekin. Þú færð tölvupóst með staðfestingu á pöntuninni.", {
            title: "Uppskrift móttekin",
            variant: 'success',
            autoHideDelay: 10000
          });

          that.submitting = false;

          that.$router.push({name: 'recipe', params: {id: data.extras.hash}})
        }
        //console.log("Success: "+ data);
        that.$root.state.recipeName = "";
        that.$root.state.recipe = [];
        that.$root.state.recipeText = "";
        that.fComment = "";
        that.$emit('exit')
      })
      .catch((error) => {
          that.$bvToast.toast("Það kom upp villa veð innsendingu á uppskriftinni. Vinsamlega athugaðu í tölvupóstinum þínum hvort hún hafi skilað sér.", {
            title: "Vesen með uppskrift",
            variant: 'warning',
            autoHideDelay: 10000
          });
          console.error(error)
      });
    },
    dateDisabled: function (ymd, date)
    {
      const weekday = date.getDay();
      const weekends = weekday === 0 || weekday === 1 || weekday === 6; // No pickup on sunday, monday, saturday
      return weekends;
    }
  },
  computed: {
    finishOrderCheck: function() {
      if (this.submitting)
        return this.submitting;

      if (this.fPhone.length > 5 && this.fEmail.length > 5 && this.fName.length > 0 && this.fDate.length > 0 && this.$root.state.recipeName.length > 0)
        return false

      return true
    }
  },
  mounted() {
    if (localStorage.name)
      this.fName = localStorage.name
    if (localStorage.phone)
      this.fPhone = localStorage.phone
    if (localStorage.email)
      this.fEmail = localStorage.email
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
